import { Spinner } from '@repo/ui'
import { observer } from 'mobx-react-lite'

import { useDialogContext } from '@/dialogs/DialogContext'
import { useDeleteSystemTriviaList } from '@/pages/trivia-lists/queries/useDeleteSystemTriviaList'

import { ManageTriviaLists } from './manage-trivia-lists'
import { validateTriviaList } from '../edit-trivia-list/utils/validate-list'
import { useQuerySystemTriviaLists } from '../queries/useQuerySystemTriviaLists'

const PAGE_TITLE = 'Manage Trivia Lists (Admin)'

export const ManageTriviaListsAdmin = observer(() => {
  const { data: triviaLists = [], isLoading } = useQuerySystemTriviaLists()
  const { mutate: deleteSystemTriviaList } = useDeleteSystemTriviaList()

  const { setConfirmPrompt } = useDialogContext()

  const handleClickDelete = (listId: string) => {
    setConfirmPrompt({
      description: 'This action cannot be undone',
      heading: 'Are you sure you want to delete this trivia list?',
      onConfirm: () => deleteSystemTriviaList(listId)
    })
  }

  if (isLoading) return <Spinner label='Loading...' />

  const validatedTriviaLists = triviaLists.map(validateTriviaList)

  return (
    <ManageTriviaLists
      baseUrl='/admin/'
      isLoading={isLoading}
      pageTitle={PAGE_TITLE}
      triviaLists={validatedTriviaLists}
      onDeleteTriviaList={handleClickDelete}
    />
  )
})
